module.exports = __webpack_public_path__ + "static/img/18091012.f6f5fdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/180910/18091012.jpg
// module id = W+sF
// module chunks = 0